import load from './../load'

export default [
  // 法规
  {
    path: '/law',
    name: 'Law',
    component: load('Law', 'law')
  },
  {
    path: '/lawlist',
    name: 'LawList',
    component: load('LawList', 'law')
  },
  {
    path: '/lawsearch',
    name: 'LawSearch',
    component: load('LawSearch', 'law')
  },
  {
    path: '/lawdetail/:id',
    name: 'LawDetail',
    component: load('LawDetail', 'law')
  },
  {
    path: '/FaLvList',
    name: 'FaLvList',
    component: load('FaLvList', 'law')
  }

]



// WEBPACK FOOTER //
// ./src/router/law/index.js